<template>
  <div class="mapContainer" ref="echart_china"></div>
</template>

<script>
import chinamap from "@/assets/json/china.json";
let myChart = null;
export default {
  name: "WoldMap",
  data() {
    return {
      data:[
        {
          name: '齐齐哈尔'
        },{
          name: '青岛'
        },{
          name: '苏州'
        },{
          name: '北京市'
        },{
          name: '金昌'
        }
      ],
      geoCoordMap:{
        '齐齐哈尔': [123.97, 47.33],
        '盐城': [120.13, 33.38],
        '青岛': [120.33, 36.07],
        '金昌': [102.188043, 38.520089],
        '泉州': [118.58, 24.93],
        '拉萨': [91.11, 29.97],
        '上海浦东': [121.48, 31.22],
        '攀枝花': [101.718637, 26.582347],
        '威海': [122.1, 37.5],
        '承德': [117.93, 40.97],
        '汕尾': [115.375279, 22.786211],
        '苏州': [120.619907, 31.317987],
        '重庆': [108.384366, 30.439702],
        '北京市': [116.4551,40.2539]
      },
      planePath:'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z',
      dataFrom:'苏州市'
    }
  },
  mounted() {
    myChart = this.$echarts.init(this.$refs.echart_china);

    //this.init();
    this.showScatterInGeo();
  },
  created() {
    window.onresize = function () {
        myChart.resize();
    }
  },
  methods:{
    randomData(){
      return Math.round(Math.random()*100);
    },
    convertData(data){
      var res = [];

      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.geoCoordMap[data[i].name];

        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          });
        }
      }

      return res;
    },
    init(){
      this.$echarts.registerMap("china", chinamap);
      // 3. 设置图表 option
      var option = {
        geo: {
          type: "map",
          map: "china", //使用 registerMap 注册的地图名称
        },
      };
      myChart.setOption(option);
    },
    showScatterInGeo(){
      //this.$echarts.registerMap("china", chinamap);
      const flightData = [
        { name: '苏州', coord: [120.619907, 31.317987]},
        { name: '北京', coord: [116.46, 39.92] },
        { name: '上海', coord: [121.48, 31.22] },
        { name: '齐齐哈尔', coord: [123.97, 47.33]},
        { name: '金昌', coord: [102.188043, 38.520089]},
        { name: '重庆',coord: [108.384366, 30.439702]},
        { name: '克拉玛依', coord: [84.77, 45.59]},
        { name: '攀枝花', coord: [101.718637, 26.582347]},
        { name: '承德', coord: [117.93, 40.97]},
        { name: '汕尾', coord: [115.375279, 22.786211]},
        { name: '盐城', coord: [120.13, 33.38]},
        { name: '威海', coord: [122.1, 37.5]},
        { name: '海南', coord: [110.3893, 19.8516]},
        { name: '青海', coord: [101.4038, 36.8207]},
        { name: '泉州', coord: [118.58, 24.93]},
        { name: '拉萨', coord: [91.11, 29.97]},
        { name: '甘肃', coord: [103.5901, 36.3043]},
        { name: '湖南', coord: [113.0823, 28.2568]},
        { name: '陕西', coord: [109.1162, 34.2004]},
        // 添加更多的城市和坐标...
      ];
      const option = {
        /*tooltip: {
          trigger: 'item'
        },*/
        animation: true,
        animationDuration: 1000,
        animationEasing: 'cubicInOut',
        animationDurationUpdate: 1000,
        animationEasingUpdate: 'cubicInOut',
        geo: {
          type: "map",
          map: "china",
          label: {
            normal: {
              show: false,
              color: '#BCCADE',
              textStyle: {
                fontSize: 16 // 设置字体大小
              }
            },
            emphasis: {
              show: false,
              color: '#FFFFFF'
            },
          },
          itemStyle: {
            normal: {
              areaColor: '#FFFFFF',
              borderColor: '#BCCADE'
            },
            emphasis: {
              areaColor: 'rgba(0,134,255,0.1)'
            }
          }
        },
        series: [
          {
            type: 'lines',
            zlevel: 2,
            symbolSize: 10,
            effect: {
              show: true,
              period: 4, //箭头指向速度，值越小速度越快
              trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: 'arrow', //箭头图标
              symbolSize: 5, //图标大小
            },
            lineStyle: {
              normal: {
                color:'rgb(30,144,255)',
                width: 0.1, //尾迹线条宽度
                opacity: 0.3, //尾迹线条透明度
                curveness: .3 //尾迹线条曲直度
              }
            },
            data: flightData.slice(1).map((item) => {
              return {
                fromName: '苏州',
                toName: item.name,
                coords: [flightData[0].coord, item.coord],
              };
            }),
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            showEffectOn: 'render',
            hoverAnimation: true,
            /*zlevel: 2,*/
            rippleEffect: {
              period: 4,
              brushType: 'stroke',
              scale: 4,
            },
            //symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#fff',
                borderColor: '#fff',
                borderWidth: 2,
              },
            },
            data: flightData.map((item) => {
              return {
                name: item.name,
                value: [...item.coord, 50], // 添加高度
              };
            }),
          },
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            rippleEffect: {
              period: 4,
              brushType: 'stroke',
              scale: 4,
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                formatter: '{b}',
                textStyle: {
                  fontSize: 18 // 设置字体大小
                }
              },
            },
            symbol: 'circle',
            symbolSize: 10, // 调整为更大的大小
            itemStyle: {
              normal: {
                color: '#0086FF', // 起点颜色
                borderColor: 'rgba(30,144,255,0.8)',
                borderWidth: 2,
              },
            },
            data: [
              {
                name: '苏州',
                value: [...flightData[0].coord, 50], // 添加高度
              },
            ],
          },
        ],
      };

      myChart.setOption(option);
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868982.otf');
}
@font-face {
  font-family: 'SourceHanSansCNBold';
  src: url('https://oss.kaoyanvip.cn/attach/file1706509868791.otf');
}
.mapContainer{
  width: 100%;
  height: 760px;
}
</style>